// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : SANCTION REPORT
// MODIFIED DATE: 29-09-2025
/* eslint-disable import/no-anonymous-default-export */
import sanctionReportTypes from './sanction-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getSanctionDetailResponse: null,
	getSanctionDetailArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FETCH SANCTION REPORT DETAILS START *********************** */
		case sanctionReportTypes.GET_SANCTION_REPORT_SUCCESS:
			return {
				...state,
				getSanctionDetailResponse: action.payload,
				getSanctionDetailArr: docodeHexResponse(
					action.payload,
					'GetSanctionReportDetailsKey',
				),
			};
		case sanctionReportTypes.GET_SANCTION_REPORT_FAILURE:
			return { ...state, getSanctionDetailResponse: action.payload };

		case sanctionReportTypes.GET_SANCTION_REPORT_RESPONSE_CHANGED:
			return { ...state, getSanctionDetailResponse: null };
		/** ***************** FETCH SANCTION REPORT DETAILS END *********************** */
		default:
			return state;
	}
};
